import { Routes, Route, useLocation } from "react-router-dom";
import { CodeAccess } from "../pages/CodeAccess";
import VideoApp from "../pages/VideoApp";

export const Router = (): JSX.Element => {
  const location = useLocation();

  return (
    <Routes location={location}>
      <Route path="acessar" element={<CodeAccess />} />
      <Route path="acessar/:code?" element={<CodeAccess />} />
      <Route path="*" element={<VideoApp />} />
    </Routes>
  );
};
